import React from 'react';
import { Form, Icon, Message } from 'semantic-ui-react'
import _find from 'lodash/find';

import EstaSeguro from '../../../components/funcionales/estaseguro'

import ListaDe from '../../../components/funcionales/dirmayor/listade';
import ListaCi from '../../../components/funcionales/dirmayor/listaci';
import selciudad from '../../../functions/selciudad';

const DetalleNivel2 = props => {
return (
  <option>{props.elemento.codigoTipoDoc}</option>
)
};

const ListaTD = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel2Detalle = list.map((elemento, _id) => <DetalleNivel2 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tipodoc" id="miLista3" value={permiteUpdate?argsDocum.codigoTipoDoc:idLista.codigoTipoDoc} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel2Detalle}
      </select>
    </div>
  )
};

const DetalleNivel1 = props => {
return (
  <option dato1={props.elemento.areaAprovech} value={props.elemento._id}>{props.elemento.descrTipoRec}</option>
)
};

const Lista = ({list, idLista, argsDocum, permiteUpdate, handleChange}) => {
  const Nivel1Detalle = list.map((elemento, _id) => <DetalleNivel1 elemento={elemento} key={elemento._id} />);
  return(
    <div>
      <select className="ui simple selection dropdown fluid" name="tiporec" id="miLista2" value={permiteUpdate?argsDocum.idTipoRec:idLista.tiporec._id} onChange={(ev)=>handleChange(ev, argsDocum)}>
        {Nivel1Detalle}
      </select>
    </div>
  )
};

class VerRec2 extends React.Component {
  state={
    argsDocum: {codigoTipoDoc: this.props.idLista.codigoTipoDoc,
                numeroDocum: this.props.idLista.numeroDocum,
                descrRecurso: this.props.idLista.descrRecurso,
                telContacto: this.props.idLista.telContacto,
                idTipoRec: this.props.idLista.tiporec._id,
                descrTipoRec: this.props.idLista.tiporec.descrTipoRec,
                areaAprovech: this.props.idLista.tiporec.areaAprovech,
                _id: this.props.idLista._id,
                _idAnterior: this.props.idLista.tiporec._id,
                _idDpto: this.props.idLista._idDpto,
                codigoDpto: this.props.idLista.codigoDpto,
                descrDpto: this.props.idLista.descrDpto,
                codigoCiudad: this.props.idLista.codigoCiudad,
                nombreCiudad: this.props.idLista.nombreCiudad,
                dirArchIn: this.props.idLista.dirArchIn,
                posIniCodCiudad: this.props.idLista.posIniCodCiudad?this.props.idLista.posIniCodCiudad:"",
                longCodCiudad: this.props.idLista.longCodCiudad?this.props.idLista.longCodCiudad:"",
                posIniContrato: this.props.idLista.posIniContrato?this.props.idLista.posIniContrato:"",
                longContrato: this.props.idLista.longContrato?this.props.idLista.longContrato:"",
                posIniNumeroDoc: this.props.idLista.posIniNumeroDoc?this.props.idLista.posIniNumeroDoc:"",
                longNumeroDoc: this.props.idLista.longNumeroDoc?this.props.idLista.longNumeroDoc:"",
                posIniFecha: this.props.idLista.posIniFecha?this.props.idLista.posIniFecha:"",
                longFecha: this.props.idLista.longFecha?this.props.idLista.longFecha:"",
                posIniNombre: this.props.idLista.posIniNombre?this.props.idLista.posIniNombre:"",
                longNombre: this.props.idLista.longNombre?this.props.idLista.longNombre:"",
                posIniApellido: this.props.idLista.posIniApellido?this.props.idLista.posIniApellido:"",
                longApellido: this.props.idLista.longApellido?this.props.idLista.longApellido:"",
                posIniValor: this.props.idLista.posIniValor?this.props.idLista.posIniValor:"",
                longValor: this.props.idLista.longValor?this.props.idLista.longValor:"",
                numPrimLinExcluir: this.props.idLista.numPrimLinExcluir?this.props.idLista.numPrimLinExcluir:0,
              },
    confirmaAct: false,
    open: false,
  }

  handleChange = (ev) => {
    if (this.props.permiteUpdate){
      this.setState({confirmaAct: false})
      // console.log(ev.target.name)
      // console.log(ev.target)
      if(ev.target.name !== "numeroDocum"){
        const argsDocum = this.state.argsDocum
        if(ev.target.name === "tiporec"){
//Se permite modificar el tipo de recurso
          //   argsDocum['idTipoRec'] = ev.target.value
          //   var miLista = document.getElementById("miLista2");
          //   argsDocum['areaAprovech'] = miLista.options[miLista.selectedIndex].attributes[0].value
          //   argsDocum['descrTipoRec'] = miLista.options[miLista.selectedIndex].text
        }else{
          if(ev.target.name === "dpto"){
            let miLista = document.getElementById("miLista");
            // argsDocum['codigoCiudad'] = miLista.options[miLista.selectedIndex].value

            if(miLista.options[miLista.selectedIndex].text==="Todos..."){
              argsDocum['_idDpto'] = "Todos..."
              argsDocum['codigoDpto'] = "Todos..."
              argsDocum['descrDpto'] = "Todos..."
              argsDocum['codigoCiudad'] = "Todas..."
              argsDocum['nombreCiudad'] = "Todas..."
            }else{
              argsDocum['_idDpto'] = miLista.options[miLista.selectedIndex].value
              argsDocum['codigoDpto'] = miLista.options[miLista.selectedIndex].attributes[0].value
              argsDocum['descrDpto'] = miLista.options[miLista.selectedIndex].text

              miLista = document.getElementById("miLista1");
              if(miLista.options[miLista.selectedIndex].text==="Todas..."){
                argsDocum['codigoCiudad'] = "Todas..."
                argsDocum['nombreCiudad'] = "Todas..."
              }else{
                argsDocum['codigoCiudad'] = miLista.options[miLista.selectedIndex].value
                argsDocum['nombreCiudad'] = miLista.options[miLista.selectedIndex].text
              }
            }
          }else{
            argsDocum[ev.target.name] = ev.target.value 
          }
        }
        this.setState({argsDocum});
      }
    }
  }

  handleQuestionUpdDel = async (ev) => {
    var btnPress = await ev.target.attributes[0].value
    if(btnPress==="btnUpdDel" && !this.state.confirmaAct){this.setState({open: true})}else{this.setState({open: false})};
    if(btnPress==="No"){
      this.setState({open: false})
    };
    if(btnPress==="Si"){
      this.setState({confirmaAct: true})
      this.setState({open: false})
      const myBtn = await document.getElementById("btnUpdDel");
      myBtn.click()
    }
  }

  render(){
    const {argsDocum, open, confirmaAct} = this.state;
    // console.log(this.props.list1)

    if(this.props.codigoCiudadUA!=="Todas..."){
      let dpto = document.getElementById("miLista");
      if(dpto){
        dpto.options.selectedIndex = 0
      }
    }
// console.log(argsDocum)
    let argsSelDpto = {...argsDocum}
    argsSelDpto._id = argsDocum._idDpto
    let colecc = selciudad(this.props.list1, argsSelDpto, this.props.codigoCiudadUA)
    let listCiu = colecc.listCiu
    let esUpd = true
// console.log(listCiu)
    let permiteUpdate = this.props.permiteUpdate
    let errors = this.props.errors
    // if(this.props.permiteUpdate&&argsDocum.nombreCiudad==="Todas..."&&listCiu.length===1){
    if(this.props.permiteUpdate&&((this.props.list1.length===0)||(argsDocum.descrDpto!=="Todos..."&&argsDocum.nombreCiudad==="Todas..."&&listCiu.length===1))){
      permiteUpdate = false
      errors.push({path: 'Modificar', message: "No puede modificar el recurso porque NO hay Departamentos o el Departamento no tiene ciudades"});
    }
    // console.log(this.props.modeloFactura)
    return(
      <div>
        <button className="ui right labeled icon button" style={this.props.styles.titBuscar}>
            <i className="large hand point down yellow icon"></i>
            Recurso
        </button>
        <div style={this.props.styles.box}>
          <Form name="form1" id="form1" onSubmit={confirmaAct?(ev)=>this.props.handleSubmit(ev, argsDocum):()=>{}}>
            <div className="ui one column stackable grid">
              <div className="row container">
                <div className="column" width="100%">
                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de documento</label>
                    <ListaTD list={this.props.list2} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <label style={this.props.styles.label}>Número de documento</label>
                    <Form.Input autoComplete="off" name="numeroDocum" id="numeroDocum" value={this.props.permiteUpdate?argsDocum.numeroDocum:this.props.idLista.numeroDocum} onChange={this.handleChange} placeholder='>Número de documento' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numeroDocum'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  {/* <Form.Field>
                    <label style={this.props.styles.label}>Descripción</label>
                    <Form.Input autoComplete="off" name="descrRecurso" id="descrRecurso" value={this.props.permiteUpdate?argsDocum.descrRecurso:this.props.idLista.descrRecurso} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrRecurso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field> */}

                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Descripción</label>
                          <Form.Input autoComplete="off" name="descrRecurso" id="descrRecurso" value={this.props.permiteUpdate?argsDocum.descrRecurso:this.props.idLista.descrRecurso} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'descrRecurso'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Teléfono de contacto</label>
                          <Form.Input autoComplete="off" name="telContacto" id="telContacto" value={this.props.permiteUpdate?argsDocum.telContacto:this.props.idLista.telContacto} onChange={this.handleChange} placeholder='Teléfono de contacto' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'telContacto'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                        </div>
                      </div>
                    </div>
                  </Form.Field>

                  <Form.Field>
                    <label style={this.props.styles.label}>Tipo de recurso</label>
                    <Lista list={this.props.list} styles={this.props.styles} idLista={this.props.idLista} argsDocum={argsDocum} permiteUpdate={this.props.permiteUpdate} handleChange={this.handleChange}/>
                  </Form.Field>
                  <Form.Field>
                    <div className="ui two column stackable grid">
                      <div className="row container">
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Departamento</label>
                          <ListaDe list={this.props.list1} styles={this.props.styles} handleLista={this.handleChange}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                            esUpd={esUpd}
                            argsDocum={argsDocum} idLista={this.props.idLista} permiteUpdate={this.props.permiteUpdate}/>
                        </div>
                        <div className="column" style={{width: '50%'}}>
                          <label style={this.props.styles.label}>Ciudad</label>
                          <ListaCi list={listCiu} styles={this.props.styles} handleLista1={this.handleChange}
                            codigoCiudadUA={this.props.codigoCiudadUA} codigoDptoUA={this.props.codigoDptoUA}
                            esUpd={esUpd}
                            argsDocum={argsDocum} idLista={this.props.idLista} permiteUpdate={this.props.permiteUpdate}/>
                        </div>
                      </div>
                    </div>
                  </Form.Field>
                  <hr></hr>
                  <Form.Field>
                    <label style={this.props.styles.label}>Carpeta para recibir archivos de recaudo</label>
                    <Form.Input autoComplete="off" name="dirArchIn" id="dirArchIn" value={this.props.permiteUpdate?argsDocum.dirArchIn:this.props.idLista.dirArchIn} onChange={this.handleChange} placeholder='Descripción' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'dirArchIn'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                  </Form.Field>
                  <hr></hr>
                  {this.props.modeloFactura==="3" &&
                  // {(this.props.modeloFactura==="99") &&
                    <div>
                      <label style={this.props.styles.label}>{"Estructura archivos de recaudo (dejar en blanco si no tiene el dato o es el dato del final de la línea y es de longitud variable)"}</label>
                      <hr></hr>
                      <Form.Field>
                        <div className="ui twuelve column stackable grid">
                          <div className="row container" style={{paddingBottom: 0}}>
                            <div className="column" style={{width: '10%'}}>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Posic inicial</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Longitud</label>
                            </div>
                            <div className="column" style={{width: '7%'}}>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Posic inicial</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Longitud</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Posic inicial</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Longitud</label>
                            </div>
                            <div className="column" style={{width: '7%'}}>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Posic inicial</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Longitud</label>
                            </div>
                          </div>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui twuelve column stackable grid">
                          <div className="row container">
                            <div className="column" style={{width: '10%'}}>
                              <label style={this.props.styles.label}>Cod Int Ciudad</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniCodCiudad" id="posIniCodCiudad" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniCodCiudad:this.props.idLista.posIniCodCiudad?this.props.idLista.posIniCodCiudad:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniCodCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longCodCiudad" id="longCodCiudad" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longCodCiudad:this.props.idLista.longCodCiudad?this.props.idLista.longCodCiudad:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longCodCiudad'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '7%'}}>
                              <label style={this.props.styles.label}>Contrato</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniContrato" id="posIniContrato" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniContrato:this.props.idLista.posIniContrato?this.props.idLista.posIniContrato:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniContrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longContrato" id="longContrato" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longContrato:this.props.idLista.longContrato?this.props.idLista.longContrato:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longContrato'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Doc Identif</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniNumeroDoc" id="posIniNumeroDoc" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniNumeroDoc:this.props.idLista.posIniNumeroDoc?this.props.idLista.posIniNumeroDoc:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniNumeroDoc'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longNumeroDoc" id="longNumeroDoc" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longNumeroDoc:this.props.idLista.longNumeroDoc?this.props.idLista.longNumeroDoc:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longNumeroDoc'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '7%'}}>
                              <label style={this.props.styles.label}>Fecha</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniFecha" id="posIniFecha" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniFecha:this.props.idLista.posIniFecha?this.props.idLista.posIniFecha:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniFecha'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longFecha" id="longFecha" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longFecha:this.props.idLista.longFecha?this.props.idLista.longFecha:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longFecha'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                          </div>
                        </div>
                      </Form.Field>
                      <Form.Field>
                        <div className="ui twuelve column stackable grid">
                          <div className="row container">
                            <div className="column" style={{width: '10%'}}>
                              <label style={this.props.styles.label}>Nombre</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniNombre" id="posIniNombre" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniNombre:this.props.idLista.posIniNombre?this.props.idLista.posIniNombre:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniNombre'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longNombre" id="longNombre" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longNombre:this.props.idLista.longNombre?this.props.idLista.longNombre:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longNombre'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '7%'}}>
                              <label style={this.props.styles.label}>Apellido</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniApellido" id="posIniApellido" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniApellido:this.props.idLista.posIniApellido?this.props.idLista.posIniApellido:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniApellido'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longApellido" id="longApellido" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longApellido:this.props.idLista.longApellido?this.props.idLista.longApellido:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longApellido'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <label style={this.props.styles.label}>Valor</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="posIniValor" id="posIniValor" type="number" step="1" value={this.props.permiteUpdate?argsDocum.posIniValor:this.props.idLista.posIniValor?this.props.idLista.posIniValor:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'posIniValor'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="longValor" id="longValor" type="number" step="1" value={this.props.permiteUpdate?argsDocum.longValor:this.props.idLista.longValor?this.props.idLista.longValor:""} onChange={this.handleChange} placeholder='Cod Int Ciudad' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'longValor'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                          </div>
                        </div>
                      </Form.Field>

                      <Form.Field>
                        <div className="ui twuelve column stackable grid">
                          <div className="row container">
                            <div className="column" style={{width: '10%'}}>
                              <label style={this.props.styles.label}>EXCLUIR</label>
                            </div>
                            <div className="column" style={{width: '8%'}}>
                              <Form.Input autoComplete="off" name="numPrimLinExcluir" id="numPrimLinExcluir" type="number" step="1" value={this.props.permiteUpdate?argsDocum.numPrimLinExcluir:this.props.idLista.numPrimLinExcluir?this.props.idLista.numPrimLinExcluir:0} onChange={this.handleChange} placeholder='' icon={!this.props.errors.length?null: _find(this.props.errors, {path:'numPrimLinExcluir'})?<Icon name="remove circle" color="red" size="large" />:<Icon name="check circle outline" color="green" size="large" />} />
                            </div>
                            <div className="column" style={{width: '40%'}}>
                              <label style={this.props.styles.label}>primeras líneas</label>
                            </div>
                          </div>
                        </div>
                      </Form.Field>
                      <hr></hr>
                    </div>
                  }

                  <EstaSeguro permiteUpdate={permiteUpdate} permiteDelete={this.props.permiteDelete} open={open} styles={this.props.styles} handleQuestionUpdDel={this.handleQuestionUpdDel}/>
                </div>
                <div className="ui one column stackable grid">
                  <div className="row container">
                    <div className="column" width="100%">
                      {
                        errors.length?<Message negative header="Los siguientes errores:"
                        list={errors.map(error=>`${error.path}: ${error.message}`)} />:null
                      }
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </Form>
        </div>
      </div>
    )
  }
}

export default VerRec2
